export enum CriticalCareConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'criticalCare/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'criticalCare/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_ACTION = 'criticalCare/SET_ACTION',
  SET_SITE = 'criticalCare/SET_SITE',
  SET_TASK = 'criticalCare/SET_TASK',
  SET_TRANSDUCER_ZEROED_PRE = 'criticalCare/SET_TRANSDUCER_ZEROED_PRE',
  SET_TRANSDUCER_ZEROED_POST = 'criticalCare/SET_TRANSDUCER_ZEROED_POST',
  SET_TRIGGER_UTILIZED_PRE = 'criticalCare/SET_TRIGGER_UTILIZED_PRE',
  SET_TRIGGER_UTILIZED_POST = 'criticalCare/SET_TRIGGER_UTILIZED_POST',
  SET_IABP_FREQUENCY_PRE = 'criticalCare/SET_IABP_FREQUENCY_PRE',
  SET_IABP_FREQUENCY_POST = 'criticalCare/SET_IABP_FREQUENCY_POST',
  SET_IABP_AUGMENTATION_PRE = 'criticalCare/SET_IABP_AUGMENTATION_PRE',
  SET_IABP_AUGMENTATION_POST = 'criticalCare/SET_IABP_AUGMENTATION_POST',
  SET_SLOW_GAS_LEAK_ALARM_PRE = 'criticalCare/SET_SLOW_GAS_LEAK_ALARM_PRE',
  SET_SLOW_GAS_LEAK_ALARM_POST = 'criticalCare/SET_SLOW_GAS_LEAK_ALARM_POST',
  SET_TIMING_PRE = 'criticalCare/SET_TIMING_PRE',
  SET_TIMING_POST = 'criticalCare/SET_TIMING_POST',
  SET_IABP_FILL_PRE = 'criticalCare/SET_IABP_FILL_PRE',
  SET_IABP_FILL_POST = 'criticalCare/SET_IABP_FILL_POST',
  SET_AUGMENTATION_ALARM_SET_PRE = 'criticalCare/SET_AUGMENTATION_ALARM_SET_PRE',
  SET_AUGMENTATION_ALARM_SET_POST = 'criticalCare/SET_AUGMENTATION_ALARM_SET_POST',
  SET_LEFT_BRACHIAL_PULSE_PRE = 'criticalCare/SET_LEFT_BRACHIAL_PULSE_PRE',
  SET_LEFT_BRACHIAL_PULSE_POST = 'criticalCare/SET_LEFT_BRACHIAL_PULSE_POST',
  SET_DISTAL_PULSE_PRESENT_IN_AFFECTED_EXTREMITY_PRE = 'criticalCare/SET_DISTAL_PULSE_PRESENT_IN_AFFECTED_EXTREMITY_PRE',
  SET_DISTAL_PULSE_PRESENT_IN_AFFECTED_EXTREMITY_POST = 'criticalCare/SET_DISTAL_PULSE_PRESENT_IN_AFFECTED_EXTREMITY_POST',
  SET_INSERTION_SITE_PRE = 'criticalCare/SET_INSERTION_SITE_PRE',
  SET_INSERTION_SITE_POST = 'criticalCare/SET_INSERTION_SITE_POST',
  SET_EXTREMITY_RESTRAINED_PRE = 'criticalCare/SET_EXTREMITY_RESTRAINED_PRE',
  SET_EXTREMITY_RESTRAINED_POST = 'criticalCare/SET_EXTREMITY_RESTRAINED_POST',
  SET_INFLATION_POINT_PRE = 'criticalCare/SET_INFLATION_POINT_PRE',
  SET_INFLATION_POINT_POST = 'criticalCare/SET_INFLATION_POINT_POST',
  SET_DEFLATION_POINT_PRE = 'criticalCare/SET_DEFLATION_POINT_PRE',
  SET_DEFLATION_POINT_POST = 'criticalCare/SET_DEFLATION_POINT_POST',
  SET_DIASTOLIC_AUGMENTATION_PRE = 'criticalCare/SET_DIASTOLIC_AUGMENTATION_PRE',
  SET_DIASTOLIC_AUGMENTATION_POST = 'criticalCare/SET_DIASTOLIC_AUGMENTATION_POST',
  SET_UNAUGMENTED_DIASTOLE_PRE = 'criticalCare/SET_UNAUGMENTED_DIASTOLE_PRE',
  SET_UNAUGMENTED_DIASTOLE_POST = 'criticalCare/SET_UNAUGMENTED_DIASTOLE_POST',
  SET_DIASTOLIC_DIP_PRE = 'criticalCare/SET_DIASTOLIC_DIP_PRE',
  SET_DIASTOLIC_DIP_POST = 'criticalCare/SET_DIASTOLIC_DIP_POST',
  SET_AUGMENTED_SYSTOLE_PRE = 'criticalCare/SET_AUGMENTED_SYSTOLE_PRE',
  SET_AUGMENTED_SYSTOLE_POST = 'criticalCare/SET_AUGMENTED_SYSTOLE_POST',
  SET_UNAUGMENTED_SYSTOLE_PRE = 'criticalCare/SET_UNAUGMENTED_SYSTOLE_PRE',
  SET_UNAUGMENTED_SYSTOLE_POST = 'criticalCare/SET_UNAUGMENTED_SYSTOLE_POST',
  ON_SELECT_CRITICAL_CARE = 'criticalCare/ON_SELECT_CRITICAL_CARE',
  SET_ADD_TO_TIMELINE = 'criticalCare/SET_ADD_TO_TIMELINE',
  SET_DATE_TIME = 'criticalCare/SET_DATE_TIME',
  SET_DATE = 'criticalCare/SET_DATE',
  SET_RESPONSE = 'criticalCare/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'criticalCare/SET_RESPONSE_PNNV',
  SAVE_CRITICAL_CARE = 'criticalCare/SAVE_CRITICAL_CARE',
  RESET_STATE = 'criticalCare/RESET_STATE',
  RESET_IABP_FIELDS = 'criticalCare/RESET_IABP_FIELDS',
  SET_ASSESSED_BY = 'criticalCare/SET_ASSESSED_BY',
  SET_PTA = 'criticalCare/SET_PTA',
  SET_TIME = 'criticalCare/SET_TIME',
  SET_ROLE_PERFORMING = 'criticalCare/SET_ROLE_PERFORMING',
  SET_COMMENTS = 'criticalCare/SET_COMMENTS',
  SET_SIZE = 'criticalCare/SET_SIZE',
  SET_ROLE_PERFORMING_PNNV = 'criticalCare/SET_ROLE_PERFORMING_PNNV',
  SET_SUCCESSFUL_ATTEMPT = 'criticalCare/SET_SUCCESSFUL_ATTEMPT',
  SET_ATTEMPTS = 'criticalCare/SET_ATTEMPTS',
  GET_PREVIOUS_CRITICAL_CARE_STATE = 'criticalCare/GET_PREVIOUS_CRITICAL_CARE_STATE',
  SET_PROCEDURE_COMPLICATIONS = 'criticalCare/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'criticalCare/SET_AUTHORIZATION',
  SET_STATE = 'criticalCare/SET_STATE',
  IABP_MAINTENANCE = 'IABP Maintenance',
  SET_DEFAULT_VALUES_FOR_IABP = 'criticalCare/SET_DEFAULT_VALUES_FOR_IABP',
}
